<div *ngIf='componentReady' class='RegisterStepPay__wrapper'>
  <div class='RegisterStepPay__wrapper__container'>
    <h3>Payment</h3>
    <p class='text-center mt-3 font-weight-bolder'>
      Select your plan and team code, then enter card, wallet, or bank details in Stripe’s secure form (USD).
    </p>
    <div
      [formGroup]='registerForm'
      class='RegisterStepPay__wrapper__container__form mt-5'>
      <div class='row mt-3'>
        <div class='col col-12 col-sm-6'>
          <h4 class='text-center'>Select Plan</h4>
          <div class='row mt-3'>
            <div class='col col-12'>
              <app-select (selection)='onPlanChange($event)' [items]='getPlanItems()' formControlName='plan_id'
                          label='Select your plan'></app-select>
            </div>
            <div class='col col-12 mt-3'>
              <app-text-field formControlName='discount' placeholder='Team Code'></app-text-field>
            </div>
          </div>
        </div>
        <div class='col col-12 col-sm-6'>
          <div *ngIf='selectedPlan' class='PlanPreview d-flex flex-column mt-5 p-3'>
            <div class='PlanPreview__title'>
              {{ selectedPlan.name }}
            </div>
            <ng-container *ngIf='discount.value; else showPrice'>
              <div class='PlanPreview__price mt-3'>
                <span class='font-weight-bolder'>Teamcode will be applied and shown on next screen.</span>
              </div>
            </ng-container>
            <ng-template #showPrice>
              <div class='PlanPreview__price mt-3'>
                <span class='font-weight-bolder'>$ {{ selectedPlan.fee }}</span>
                <span class='text-muted'> / {{ selectedPlan.period }}</span>
              </div>
              <div class='PlanPreview__price'>
                <span class='font-weight-bolder'>$ {{ selectedPlan.setup_fee }}</span>
                <span class='text-muted'> set up</span>
              </div>
            </ng-template>
            <p class='PlanPreview__pointer mt-3 text-muted'>up to {{ selectedPlan.contacts_limit }} contacts</p>
            <p class='PlanPreview__pointer text-muted'>{{ selectedPlan.send_limit }} emails sent per day</p>
            <p *ngIf='selectedPlan.vsm' class='PlanPreview__pointer text-muted'>Dedicated EDGE support</p>
          </div>
        </div>
      </div>
      <div class='row mt-3' *ngIf='paymentElementReady'>
        <div class='col col-12'>
          <p class='text-muted small'>Payment details (card, wallets, or bank debits available in your region):</p>
          <div #peContainer class='register-pe-container mb-3'></div>
          <app-button
            [Click]='confirmPeAndSubscribe'
            [color]="'orange'"
            [disabled]='peConfirming || peCompleting'
            [size]="'normal'"
            [style]="'rounded'"
            [text]="peConfirming || peCompleting ? 'Processing…' : 'Confirm and subscribe'"></app-button>
        </div>
      </div>
      <div *ngIf='!paymentElementReady' class='row mt-3'>
        <div class='col'>
          <app-button
            #buttonComponent
            [Click]='submitForm'
            [color]="'orange'"
            [observeApi]='true'
            [size]="'normal'"
            [style]="'rounded'"
            [text]="'Continue to secure payment'"></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
